import type {UserBlockProps} from '@interfaces/Profile';
import type {ReactElement} from 'react';
import TextButton from '@components/Button/TextButton';
import I18n from '@components/I18n';

export default function UserBlockFallback(props: UserBlockProps): ReactElement<UserBlockProps> {
    return (
        <div className="user-block__form--sparse">
            <div className="user-block__email">{props.initialEmail}</div>
            <div className="user-block__password">
                <TextButton type="button">
                    <I18n code="Profile_userBlock_changePassword" />
                </TextButton>
            </div>
            <TextButton type="button" disabled>
                <I18n code="Profile_userBlock_save" />
            </TextButton>
        </div>
    );
}
